import "core-js/modules/es.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry

Description:
*/
import React from 'react';
import accessibleIcon from 'wfui-digital-core/es/accessibleIcon';
import SvgIcon from 'wfui-digital-core/es/SvgIcon';
import styles from './AlertBellIcon.less';

var AlertBellIcon = function AlertBellIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    className: styles.alertBell
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-346.000000, -334.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(345.000000, 333.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-fill": true,
    d: "M3,14 L4.2,13 C3.96,13.1338346 4.02,12.9894737 4.2,13 L4.2,7 C4.02,5.44661654 5.52,3.67819549 7.8,3 C7.92,3.10075188 8.1,2.90225564 7.8,3 C8.2,2.2887218 8.56,2 9,2 C9.44,2 9.82,2.2887218 10.2,3 C9.88,2.92030075 10.06,3.10075188 10.2,3 C12.46,3.67819549 13.98,5.46466165 13.8,7 L13.8,13 C13.98,12.9894737 14.04,13.1338346 13.8,13 L15,14 L3,14 Z M11,15 C10.9090909,15.5957447 10.0454545,16 9,16 C7.86363636,16 7,15.5957447 7,15 L7,15 L11,15 C10.9545455,15.0425532 10.9090909,15.0638298 11,15 L11,15 Z M14.7142857,13 L14.7142857,8 C15.1397006,5.14222222 13.4334415,3.04444444 11.2857143,2 C10.695491,1.53333333 9.90188214,1 9,1 C8.07658178,1 7.28297293,1.53333333 6.71428571,2 C4.52518217,3.02666667 2.83876337,5.14222222 3.28571429,8 L3.28571429,13 L1,14 C0.993622786,14.2622222 0.953942343,14.4935111 1,15 C1.15234456,14.92 1.37058699,15.0444444 2.14285714,15 L6.71428571,15 C6.88616851,16.1644444 7.83849913,17 9,17 C10.1399648,17 11.0922954,16.1644444 11.2857143,15 L15.8571429,15 C16.6277172,15.0444444 16.8657998,14.92 17,15 C17.0443618,14.5111111 16.9848411,14.28 17,14 L14.7142857,13 Z"
  })))));
};

AlertBellIcon.defaultProps = {
  width: '16px',
  height: '16px',
  viewBox: '0 0 16 16'
};
export default /*#__PURE__*/React.memo(accessibleIcon(AlertBellIcon));